export default __webpack_public_path__ + "static/media/safari-settings-steps-ios-18.8c28d5a8.png";